export default __webpack_public_path__ + "static/media/remoteH.bc6adfcc.png";